<template>
  <div>
    <!-- :class="{ 'upload-demo': config.listType !== 'picture-card' && config.listType !== 'picture' }" -->
    <el-upload ref="rebateUpload" :show-file-list="config.showFileList" :action="config.customAction || ''"
      :headers="Object.assign(headers, config.headers)" :accept="config.accept" :data="config.uploadData"
      :before-upload="beforeUpload" :on-success="handleSuccess" :on-error="handleError" :on-preview="handlePreview"
      :on-remove="handleRemove" :file-list="fileList" :auto-upload="config.autoUpload" :list-type="config.listType"
      :disabled="config.disabled" :limit="config.limit" :on-exceed="handleExceed" :on-change="handleChange">
      <template v-if="config.listType !== 'picture-card' && config.listType !== 'picture'">
        <slot name="upload-button" v-if="config.listType !== 'picture-card' && config.listType !== 'picture'">
          <el-button size="small" type="primary">点击上传</el-button>
        </slot>

      </template>
      <template v-else>
        <img v-if="imgUrl && config.listType === 'picture'" :src="imgUrl" @click="showPicture()" class="avatar" />
        <i v-if="!imgUrl && config.listType === 'picture'" class="el-icon-plus avatar-uploader-icon"></i>
        <i v-if="config.listType == 'picture-card'" class="el-icon-plus"></i>
      </template>
      <div slot="tip" class="el-upload__tip">
        <slot name="tip"></slot>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body width="60%" :close-on-click-modal="false">
      <img width="60%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import store from '../vuex/store';

export default {
  data () {
    return {
      headers: {
        'Authorization': store.state.logintoken
      },
      dialogImageUrl: '',
      dialogVisible: false,
    }
  },
  props: {
    imgUrl: String,
    fileList: {
      type: Array,
      default: _ => []
    },

    config: {
      type: Object,
      default: () => ({
        action: '',
        accept: '',
        headers: {},
        showFileList: true,
        customAction: '',
        data: {},
        autoUpload: true,
        listType: 'text',
        disabled: false,
        limit: 0,
        onExceed: () => { },
        onRemove: () => { },
        onPreview: () => { },
        onSuccess: () => { },
        onError: () => { },
        onProgress: () => { },
        onBeforeUpload: () => { },
      })
    }
  },
  watch: {
    fileList: {
      handler (val) {
        console.log(val);
    
      },
      deep: true
    }
  },
  methods: {
    showPicture () {
      if (this.config.disabled) {
        if (this.imgUrl) {
          this.dialogImageUrl = this.imgUrl;
          this.dialogVisible = true;
          this.$emit('upload-preview',  this.imgUrl);
        } else {
          this.handlePreview(this.fileList[0])

        }
      }
    },
    beforeUpload (file) {
      this.$store.state.loading = true;
      // 使用 Promise 包装异步逻辑
      const limitation = new Promise((resolve, reject) => {
        this.$emit('beforeUpload', file, fun => {
          const res = fun;
          if (res) {
            resolve()
          } else {
            this.$store.state.loading = false;
            reject()
          }
        });
      });
      // 返回一个 Promise，实际上传逻辑在 then 方法中处理
      return limitation;
    },

    handleSuccess (response, file, fileList) {
      this.$store.state.loading = false;
      console.log('handleSuccess', response, file, fileList);
      this.$emit('update:value', fileList);
      this.$emit('upload-success', response, file, fileList);
    },
    handleError (error, file, fileList) {
      this.$store.state.loading = false;
      console.log('handleError', error, file, fileList);
      this.$emit('upload-error', error, file, fileList);
    },
    handlePreview (file) {
      console.log('handlePreview', file);
      if (this.config.listType === 'picture-card' || this.config.listType === 'picture') {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
      this.$emit('upload-preview', file);
    },
    handleRemove (file, fileList) {
      console.log('handleRemove', file, fileList);
      this.$emit('update:value', fileList);
      this.$emit('upload-remove', file, fileList);
    },
    handleExceed (files, fileList) {
      if (this.config.limit == 1) {//只有一个文件的时候，再次点击直接上传替换
        this.$set(fileList[0], "raw", files[0]);
        this.$set(fileList[0], "name", files[0].name);
        this.$refs["rebateUpload"].clearFiles(); //清除文件
        this.$refs["rebateUpload"].handleStart(files[0]); //选择文件后的赋值方法
        this.$refs["rebateUpload"].submit();
      } else {
        this.$message({ message: '超出可上传个数！', type: 'error' })

      }
      console.log('handleExceed', files, fileList);
      this.$emit('upload-exceed', files, fileList);
    },
    //  状态改变
    handleChange (data, fileList) {
      this.$emit('uploadChange', data, fileList);
    }
  }
};
</script>

<style scoped>
.upload-demo {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 180px;
  border: 1px dashed #409EFF;
  background-color: #f0f0f0;
  color: #909399;
  text-align: center;
  cursor: pointer;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border-radius: 10px;
  border: 1px dashed;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/myUpload.vue